import React, { useState } from 'react';
import { Star } from 'lucide-react';

// Star rating. readOnly for display; interactive when onChange provided.
export default function StarRating({ value = 0, onChange, readOnly = false, size = 18, className = '', testId }) {
    const [hover, setHover] = useState(0);
    const active = hover || value;

    return (
        <div className={`inline-flex items-center gap-0.5 ${className}`} data-testid={testId} role={readOnly ? 'img' : 'radiogroup'} aria-label={`${value} out of 5 stars`}>
            {[1, 2, 3, 4, 5].map((n) => {
                const filled = n <= active;
                const StarEl = (
                    <Star
                        style={{ width: size, height: size, color: filled ? '#C9A227' : 'rgba(90,36,50,0.28)' }}
                        fill={filled ? '#C9A227' : 'none'}
                        strokeWidth={1.6}
                    />
                );
                if (readOnly) return <span key={n}>{StarEl}</span>;
                return (
                    <button
                        key={n}
                        type="button"
                        data-testid={testId ? `${testId}-star-${n}` : undefined}
                        onMouseEnter={() => setHover(n)}
                        onMouseLeave={() => setHover(0)}
                        onClick={() => onChange && onChange(n)}
                        aria-label={`Rate ${n} star${n > 1 ? 's' : ''}`}
                        className="p-0.5 transition-transform hover:scale-110"
                    >
                        {StarEl}
                    </button>
                );
            })}
        </div>
    );
}
